import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router'
import icon from '../../../../../assets/Images/icon.png'
import logo from '../../../../../assets/Images/logos/logodark.svg'
import { login } from '../../../../../redux/actions/auth'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../shared/components/ScreenLoading'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import HiddenMobile from '../../../../shared/styles/HiddenMobile'
import { GridForm, WarningBox } from '../../../../shared/styles/LoginRegisterStyle'

const Login = ({ authFrom = 'root' }: any) => {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { isAuth, user: authUser, loading, msg, error } = useSelector((state: IRootState) => state.auth)

  const [user, setUser] = useState({
    email: '',
    password: '',
    rememberme: false,
    showPassword: false
  })

  useEffect(() => {
    if (localStorage.getItem('isAuth') && authFrom === 'root') {
      if (isAuth && authUser !== null && authUser.verification === 1) {
        navigate('/inicio')
      } else {
        if (localStorage.getItem('lastSeminarLessonId') != null && isAuth && authUser !== null && authUser.verification === 0) {
          const lastSeminarLessonId = localStorage.getItem('lastSeminarLessonId')
          localStorage.removeItem('lastSeminarLessonId')
          navigate(`/seminarios/${lastSeminarLessonId}`)
        } else {
          navigate('/inicio')
        }
      }
    }
  }, [])

  useEffect(() => {
    if (isAuth && authUser !== null && authFrom === 'root') {
      if (authUser.verification === 1) {
        navigate('/inicio')
      } else {
        if (localStorage.getItem('lastSeminarLessonId') != null && isAuth && authUser !== null && authUser.verification === 0) {
          const lastSeminarLessonId = localStorage.getItem('lastSeminarLessonId')
          localStorage.removeItem('lastSeminarLessonId')
          navigate(`/seminarios/'${lastSeminarLessonId}`)
        } else {
          navigate('/inicio')
        }
      }
    }
  }, [isAuth])

  const handleSubmit = () => {
    const { email, password, rememberme } = user

    dispatch(login({ email, password, rememberme, authFrom }))
  }

  const handleClickShowPassword = () => {
    setUser({ ...user, showPassword: !user.showPassword })
  }

  const handleChangeInput = (nameInput: string) => (event: any) => {
    setUser({ ...user, [nameInput]: event.target.value })
  }

  const handleCheckChange = (event: any) => {
    setUser({ ...user, rememberme: event.target.checked })
  }

  let isLive = authFrom === 'seminar' ? 'seminar' : ''
  return (
    <Grid
      sx={theme => ({
        minHeight: '88vh',
        justifyContent: 'center',
        alignContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
          minHeight: 'auto',
          width: '100% !important'
        },
        '&.seminar': {
          minHeight: 'auto'
        }
      })}
      container
      className={isLive ? isLive : ''}
    >
      <GridForm className={isLive ? isLive : ''}>
        <Grid
          sx={theme => ({
            width: '100% !important',
            [theme.breakpoints.down('sm')]: {
              width: 'auto !important',
              '& .MuiGrid-item': {
                padding: 1
              }
            }
          })}
          container
          spacing={isMobile ? 2 : 3}
        >
          {authFrom === 'root' && (
            <Grid xs={12} sx={{ marginBottom: 5 }}>
              <img src={logo} height="36" alt="logo" />
            </Grid>
          )}

          <Grid xs={12}>
            <FormControl variant="standard" fullWidth>
              <Box mb={0.5}>
                <Typography>{t('email')}</Typography>
              </Box>
              <InputBase
                inputProps={{ 'data-testid': 'txt-email' }}
                id="txt-email"
                placeholder={t('email')}
                onChange={handleChangeInput('email')}
                fullWidth
              />
            </FormControl>
          </Grid>

          <Grid xs={12}>
            <FormControl variant="standard" fullWidth>
              <Box display="flex" justifyContent="space-between" mb={0.5}>
                <Typography>{t('login.password')}</Typography>
                <Link style={{ color: import.meta.env.VITE_COLOR_PRIMARY_MAIN || '#FC3E6F', fontSize: '12px' }} to={'/recordar-contrasena'}>
                  {t('login.forgot-your-password')}
                </Link>
              </Box>
              <InputBase
                inputProps={{ 'data-testid': 'txt-password' }}
                placeholder={t('login.password')}
                id="txt-password"
                required
                type={user.showPassword ? 'text' : 'password'}
                onChange={handleChangeInput('password')}
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={event => event.preventDefault()}
                      edge="end"
                    >
                      {user.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>

          <Grid xs={12}>
            <FormControl fullWidth>
              <FormControlLabel
                control={<Checkbox id="chck-remember-me" checked={user.rememberme} onChange={handleCheckChange} name="jason" />}
                label={t('login.remember-me')}
              />
            </FormControl>
          </Grid>

          <Grid xs={12}>
            <Button data-testid="btn-login" id="btn-login" variant="contained" fullWidth onClick={() => handleSubmit()}>
              {t('login.login')}
            </Button>
          </Grid>

          <Grid xs={12}>
            <HiddenDesktop>
              <Box display="flex" alignItems="center" width="100%" sx={{ gap: '16px' }} justifyContent="center" mb={2} overflow="hidden">
                <Divider sx={{ width: '100%' }} />
                <Typography>o</Typography>
                <Divider sx={{ width: '100%' }} />
              </Box>
              <Button
                sx={{
                  padding: '9px 16px',
                  borderColor: 'primary.main',
                  border: '1px solid',
                  margin: 0,
                  color: 'primary.main',
                  '&:hover': {
                    color: 'common.white',
                    bgcolor: 'primary.dark'
                  }
                }}
                id="btn-login"
                variant="outlined"
                fullWidth
                component={Link}
                to="/registro"
              >
                {t('footer.signup')}
              </Button>
            </HiddenDesktop>
          </Grid>
            {import.meta.env.VITE_NAME === 'PLEI' && (    
            <>
              <Grid xs={12}>
                <WarningBox mt={6}>
                  <Typography align="center">
                    ¿TIENES CUENTA EN PLEI?
                    <br /> RESTAURA TU CLAVE ANTES DE ENTRAR
                  </Typography>
                  <List
                    sx={{
                      '& li': {
                        fontSize: '15px',
                        marginBottom: '-17px'
                      },
                      '& li span': {
                        fontSize: '15px'
                      }
                    }}
                    component="nav"
                  >
                    <ListItem>
                      <ListItemText>
                        1. Haz clic en{' '}
                        <Button size="small" color="primary" component={Link} to="/recordar-contrasena">
                          ¿Has olvidado tu contraseña?
                        </Button>
                      </ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="2. Mira tu correo y reestablece la contraseña" />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary="3. Accede a PLEI con tu nueva contraseña" />
                    </ListItem>
                  </List>
                  <HiddenMobile>
                    <img src={icon} alt="logo" />
                  </HiddenMobile>
                </WarningBox>
              </Grid>

              <Grid xs={12}>
                <Typography sx={{ color: 'grey', marginTop: '18px', fontSize: '13px' }}>{t('login.quote')}</Typography>
              </Grid>
            </>
            )}

          <Grid xs={12}>
            <HiddenDesktop>
              <Button
                sx={theme => ({
                  padding: '9px 16px',
                  borderColor: theme.palette.primary.main,
                  border: '1px solid',
                  margin: 0,
                  color: theme.palette.primary.main,
                  '&:hover': {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.primary.dark
                  }
                })}
                id="btn-login"
                variant="outlined"
                fullWidth
                href="https://plei.drv.es/preguntas-frecuentes/"
              >
                {t('help')}
              </Button>
            </HiddenDesktop>
          </Grid>
        </Grid>

        <CustomSnackBar errors={[error]} msgs={[msg]} />
        <ScreenLoading loadings={[loading]} />
      </GridForm>
    </Grid>
  )
}

export default Login
